module.exports = __webpack_public_path__ + "img/1073056e053df48fba6fcf9b06a66779.png";